module.exports = __webpack_public_path__ + "static/media/cervejaria.55d61bf4.jpg";